import React, { Fragment } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './Button';
interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  totalItems?: number;
  pageSize?: number;
  onPageSizeChange?: (size: number) => void;
}
export function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  totalItems,
  pageSize,
  onPageSizeChange
}: PaginationProps) {
  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, '...', totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
      }
    }
    return pages;
  };
  return <div className="flex flex-col sm:flex-row items-center justify-between gap-4 py-4 px-2" data-id="element-473">
      {totalItems !== undefined && pageSize !== undefined && <div className="flex items-center gap-4 text-sm text-slate-500" data-id="element-474">
          <span data-id="element-475">
            Mostrando{' '}
            <span className="font-semibold text-slate-900" data-id="element-476">
              {Math.min((currentPage - 1) * pageSize + 1, totalItems)}
            </span>{' '}
            -{' '}
            <span className="font-semibold text-slate-900" data-id="element-477">
              {Math.min(currentPage * pageSize, totalItems)}
            </span>{' '}
            di{' '}
            <span className="font-semibold text-slate-900" data-id="element-478">{totalItems}</span>
          </span>
          {onPageSizeChange && <select value={pageSize} onChange={e => onPageSizeChange(Number(e.target.value))} className="ml-2 border-slate-200 rounded-lg text-sm focus:ring-seform-orange focus:border-seform-orange" data-id="element-479">
              <option value={10} data-id="element-480">10 per pagina</option>
              <option value={25} data-id="element-481">25 per pagina</option>
              <option value={50} data-id="element-482">50 per pagina</option>
              <option value={100} data-id="element-483">100 per pagina</option>
            </select>}
        </div>}

      <div className="flex items-center gap-1" data-id="element-484">
        <Button variant="flat" size="sm" disabled={currentPage === 1} onClick={() => onPageChange(currentPage - 1)} className="!px-2" data-id="element-485">
          <ChevronLeft className="h-4 w-4" data-id="element-486" />
        </Button>

        {getPageNumbers().map((page, idx) => <Fragment key={idx} data-id="element-487">
            {page === '...' ? <span className="px-2 text-slate-400" data-id="element-488">...</span> : <button onClick={() => onPageChange(page as number)} className={`
                  w-8 h-8 flex items-center justify-center rounded-lg text-sm font-medium transition-colors
                  ${currentPage === page ? 'bg-seform-orange text-white shadow-md shadow-orange-500/30' : 'text-slate-600 hover:bg-slate-100'}
                `} data-id="element-489">
                {page}
              </button>}
          </Fragment>)}

        <Button variant="flat" size="sm" disabled={currentPage === totalPages} onClick={() => onPageChange(currentPage + 1)} className="!px-2" data-id="element-490">
          <ChevronRight className="h-4 w-4" data-id="element-491" />
        </Button>
      </div>
    </div>;
}